import { FC } from 'react';
import { CustomSkeleton } from './CreatorProfile.style';
const CreatorProfileSkeleton: FC = () => {
  return <CustomSkeleton avatar paragraph={{
    rows: 0
  }} active />;
};
export default CreatorProfileSkeleton;